import {
	FontIconName,
	FontIconValue,
	Icon
} from "client/Components";
import styles from "./IconThumbnail.module.less";
import classNames from "classnames";
import { ReactElement } from "react";
import { setTrackingId } from "client/Misc/utils";
import { AppColorViewModel } from "client/Api/Apps/common";
import { getReactColorAttributes } from "client_legacy/ndaw/appColor";

export type IconThumbnailProps = {
	icon:
		| FontIconName
		| FontIconValue;
	trackingId: string;
	color: AppColorViewModel;
};

export const IconThumbnail = (props: IconThumbnailProps): ReactElement => {
	const {
		icon,
		trackingId,
		color
	} = props;

	const {
		colorClass,
		colorStyle
	} = getReactColorAttributes(color);

	return (
		<div
			{...setTrackingId(trackingId)}
			style={colorStyle}
			className={classNames(
				colorClass,
				styles.root
			)}
		>
			<Icon value={icon} size="large" />
		</div>
	);
};
IconThumbnail.displayName = "IconThumbnail";